import { Check, Alert } from '../icons'
import { useToasts } from '../hooks/useToasts'

export function ToastStack() {
  const { toasts } = useToasts()
  return (
    <div className="toast-stack">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast--${t.kind}`}>
          <span className="toast__icon">{t.kind === 'success' ? <Check /> : <Alert />}</span>
          <span>{t.text}</span>
        </div>
      ))}
    </div>
  )
}
